import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { LoaderHolder } from 'features/GameArea/styled'
import Loader from 'ui/Loader'
import { BACKGROUNDS } from 'themes'
import { GameWrapper, MiniStyledIframe } from 'features/MinimizeScreen/styled'
import PropTypes from 'prop-types'
import GameCommunicatorService, {
    ACTION_LIST,
} from 'common/Services/GameCommunicatorService'
import GamesService from 'common/Services/GamesService'
import userService from 'common/Services/UserService'
import UrlHistoryService from 'common/Services/UrlHistoryService'
import { detectMobile } from 'common/adapters/DeviceDetectAdapter'
import { startGame } from 'services/GameLaunchService'
import { ModalService } from 'services/ModalService'

const MiniGameWrapper = ({ load, launchUrl, multiScreenMode, provider }) => {
    const history = useHistory()

    const goBack = () => {
        history.push(UrlHistoryService.getUrl())
        userService.setIsUserLoggedIn()
    }

    const onLoadGame = (e) => {
        const matchedPostMessageAction = Object.entries(ACTION_LIST).find(
            ([urlPart]) => launchUrl.includes(urlPart)
        )

        if (matchedPostMessageAction) {
            const [, { eventType }] = matchedPostMessageAction

            GameCommunicatorService.init(e.target, launchUrl)

            GameCommunicatorService.postMessage({
                messageType: 'addEventListener',
                eventType: eventType,
            })

            GameCommunicatorService.onGameExit = () => {
                console.log('onGameExit test')
                GamesService.getEndGame()
                GamesService.cleanMinimizedData()
                goBack()
            }
        }
    }

    useEffect(
        () => {
            GameCommunicatorService.multiScreenMode = multiScreenMode
        },
        [multiScreenMode]
    )

    return (
        <GameWrapper crop={provider === 'scientific' && multiScreenMode}>
            {load && (
                <LoaderHolder my={3}>
                    <Loader color={BACKGROUNDS.primary} />
                </LoaderHolder>
            )}
            {launchUrl && (
                <MiniStyledIframe
                    src={launchUrl}
                    name="gameIframe"
                    onLoad={onLoadGame}
                    crop={provider === 'scientific' && multiScreenMode}
                />
            )}
        </GameWrapper>
    )
}

MiniGameWrapper.propsTypes = {
    load: PropTypes.bool,
    launchUrl: PropTypes.string,
    gameId: PropTypes.string,
}

export default MiniGameWrapper
